module.exports = __webpack_public_path__ + "img/msg1.8bdbec8f.png";